import * as Types from "actions/types";
import axios from "axios";
import {endpoints} from "variables/variables.jsx";


export function getUserDetailsPromise(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.public+"/user/details",
    headers: { Authorization: `Bearer ${token}` }
  })
  .then(res => {     
      
      var data = {};

      if(res.data.err&&res.data.err.username&&res.data.err.email){
        data = res.data.err;
        dispatch(getDetailsPartialSuccess(data));
        return data;        
      }

      data = res.data.data;

      if( data.roles === null ){
        data.roles = Types.USER_ROLES_INITIAL_STATE;
      }else{
        data.roles = JSON.parse(data.roles);
      }
      dispatch(getDetailsSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getDetailsFailure(res)));  
}

export function getUserDetails(user) {

  return (dispatch, failure) => {
    dispatch(getDetails());
    return getUserDetailsPromise(user, dispatch);
  };
}

function getDetails() {
  return {
    type: Types.USER_GET_DETAILS
  };
}

function getDetailsPartialSuccess(user) {   
  return {
    type: Types.USER_GET_DETAILS_PARTIAL_SUCCESS,
  };
}

function getDetailsSuccess(user) {   
  return {
    type: Types.USER_GET_DETAILS_SUCCESS,
  };
}

function getDetailsFailure(res) {
  return {
    type: Types.USER_GET_DETAILS_FAILURE
  }
}


export function putUserDetails(user, data) {

  return (dispatch, failure) => {
    dispatch(putDetails());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "put",
      url: endpoints.public+"/user/details",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(putDetailsSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(putDetailsFailure()));
  };
}


function putDetails() {
  return {
    type: Types.USER_PUT_DETAILS
  };
}

function putDetailsSuccess(user, data) {   

  return {
    type: Types.USER_PUT_DETAILS_SUCCESS,
    userDetails: data,
  };
}

function putDetailsFailure() {
  return {
    type: Types.USER_PUT_DETAILS_FAILURE
  }
}


export function getAdminUsersPromise(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.admin+"/user/all/",
    headers: { Authorization: `Bearer ${token}` }
  })
  .then(res => {     
      
      var data = res.data.data;

      dispatch(getUsersSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getUsersFailure(res)));  
}

export function getAdminUsers(user) {

  return (dispatch, failure) => {
    dispatch(getUsers());
    return getAdminUsersPromise(user, dispatch);
  };
}


function getUsers() {
  return {
    type: Types.USERS_GET
  };
}
function getUsersSuccess(users) {   
  return {
    type: Types.USERS_GET_SUCCESS,
    users
  };
}

function getUsersFailure(res) {
  return {
    type: Types.USERS_GET_FAILURE
  }
}

export function postCustomerApplication(user, data) {

  return (dispatch, failure) => {
    dispatch(postApplication());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "post",
      url: endpoints.public+"/user/customer-application",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {
      return getUserDetailsPromise(user, dispatch);
    }).then( res =>{     
      dispatch(postApplicationSuccess(user, res));
      return user;
    })
    .catch(() => dispatch(postApplicationFailure()));
  };
}


export function postReceiverApplication(user, data) {

  return (dispatch, failure) => {
    dispatch(postApplication());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "post",
      url: endpoints.public+"/user/receiver-application",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {
      return getUserDetailsPromise(user, dispatch);
    }).then( res =>{     
      dispatch(postApplicationSuccess(user, res));
      return user;
    })
    .catch(() => dispatch(postApplicationFailure()));
  };
}

function postApplication() {
  return {
    type: Types.USER_APPLICATION
  };
}
function postApplicationSuccess(user, data) {   
  return {
    type: Types.USER_APPLICATION_SUCCESS,
    userDetails: data,
  };
}

function postApplicationFailure(res) {
  return {
    type: Types.USER_APPLICATION_FAILURE
  }
}

export function postUserAvatar(user, file, base64) {

  return (dispatch, failure) => {
    dispatch(postUpload());
    let token = user.signInUserSession.idToken.jwtToken;

    var data = {
      image: base64,
      name: file.name,
      type: file.type,
      size: file.size,
    };

    return axios({
      method: "post",
      url: endpoints.public+"/user/avatar",
      headers: { 
        Authorization: `Bearer ${token}`, 

      },
      data
    }).then( res =>{
      setTimeout(() => {
        dispatch(postUploadSuccess(user, res));;
      }, 1000);  
      return user;
    })
    .catch(() => dispatch(postUploadFailure()));
  };
}


function postUpload() {
  return {
    type: Types.USER_UPLOAD
  };
}
function postUploadSuccess(user, data) {   
  return {
    type: Types.USER_UPLOAD_SUCCESS,
    userId: user.signInUserSession.accessToken.payload.sub,    
  };
}

function postUploadFailure(res) {
  return {
    type: Types.USER_UPLOAD_FAILURE
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js